<template>
  <ODialog ref="dialog" hideWhenLoading>
    <v-card>
      <ODialogBar title="Detalhes" @close="$refs.dialog.$dismiss()" />
      <v-card-text class="pa-3 maxh-4">
        <pre class="mono">{{ json }}</pre>
      </v-card-text>
      <v-card-actions class="pa-6">
        <v-btn text @click="doCopy">
          <v-icon>mdi-window-restore</v-icon>
        </v-btn>
        <v-spacer />
        <v-btn text large @click="$refs.dialog.$dismiss()">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </ODialog>
</template>

<script>
export default {
  data() {
    return {
      value: null
    }
  },
  computed: {
    json() {
      if (this.value == null) return 'null'

      const replacer = (key, value) =>
        // eslint-disable-next-line valid-typeof
        typeof value === 'bigint' ? value.toString() + 'n' : value

      return JSON.stringify(this.value, replacer, ' ')
    }
  },
  methods: {
    open(value) {
      this.value = value
      return this.$refs.dialog.$open()
    },
    doCopy() {
      this.$refs.dialog.$dismiss()
      this.$emit('openMiniParser', { frame: this.value })
    }
  }
}
</script>

<style></style>
